import React from 'react';

export const Header = (): React.ReactElement => {
return (
    <div className='container mx-auto w-full md:w-2/3'>
        <div className='flex flex-col m-4 md:mx-0'>
            <p className='text-4xl font-extrabold'>King Noodle House</p>
            <p className='text-xl uppercase'>Pho Hoang</p>
            <div className='flex items-center justify-between mt-2'>
                <div className='flex italic text-gray-400'>
                    <p>10613 - 97ST NW&nbsp;</p>
                    <p>Edmonton, AB&nbsp;</p>
                    <a href="tel:7804288983" className='underline text-blue-700'>(780) 428-8983</a>
                </div>
                <p className='font-extrabold text-red-700 uppercase'>Cash Only</p>
            </div>
        </div>
    </div>
);
};
